export const COLLECTION_HOLDERS_TABLE_COLUMN_CLASSNAMES = {
  wallet: "z-[1] w-[180px] grow-[2]",
  owned: "w-[150px] grow",
  percent: "w-[110px] grow",
  items: "w-[360px] grow",
  value: "w-[110px] grow justify-end",
  portfolio: "w-[130px] grow justify-end",
}

export const COLLECTION_HOLDERS_TABLE_COMPACT_COLUMN_CLASSNAMES = {
  wallet: "z-[1] w-[180px] grow-[2]",
  owned: "w-[150px] grow",
  percent: "w-[110px] grow",
  items: "w-[240px] grow",
  value: "w-[110px] grow justify-end",
  portfolio: "w-[130px] grow justify-end",
}
